import BankDetails from './bank-details';
import BusinessInfo from './business-info';
import Documents from './Documents';
import Gallery from './gallery';
import GoogleProfile from './google-profile';
import Impressum from './impressum';
import Imprint from './imprint';
import PersonalInfo from './personal-info';
import Seo from './seo';
import Settings from './settings';
import ShippingInfo from './shipping-info';
import TaxDetails from './tax-details';
import TaxCurrency from './tax-currency';
import PostLaunch from './PostLaunch';

export default {
  BankDetails,
  BusinessInfo,
  Documents,
  Gallery,
  GoogleProfile,
  Impressum,
  Imprint,
  PersonalInfo,
  Seo,
  Settings,
  ShippingInfo,
  TaxDetails,
  TaxCurrency,
  PostLaunch,
};
